import { useRender } from "@base-ui/react/use-render";
import type { ReactElement } from "react";

import { STRETCHED_LINK } from "../foundations/interaction.js";
import { useLinkRender } from "../foundations/linkContext.js";

export interface CardLinkProps {
  href?: string;
  /** The app's own link element, which wins over the LinkProvider's. */
  render?: ReactElement;
  /** The card's name: what a screen reader hears as the link. */
  children: string;
}

/**
 * The card's name as its link, stretched over the whole `Card action="link"`, so a screen reader
 * hears "name, link" rather than everything on the card. With no `href` or `render` it is the
 * name alone.
 */
export function CardLink({ href, render, children }: CardLinkProps) {
  const linked = Boolean(href || render);
  const link = useRender({
    render: useLinkRender(render),
    defaultTagName: "a",
    enabled: linked,
    props: { href, className: STRETCHED_LINK, children },
  });
  return linked ? link : children;
}
